import React, { useEffect } from "react";
import { Experience } from "../../components/ui/Experience";
import { SiteFrame } from "../../components/ui/SiteFrame";
import Mixpanel from "../../lib/mixpanel";
import Seo from "../../components/Seo";

export default function ExperiencePage() {
  useEffect(() => {
    Mixpanel.trackExperience();
  }, []);

  return (
    <SiteFrame>
      <Seo
        title="Experience"
        path="/experience"
        description="The professional experience and roles of Krushil Amrutiya — internships, work, and projects across tech and beyond."
      />
      <Experience />
    </SiteFrame>
  );
}
